import Text from 'components/Text/Text';
import React, { useCallback, useState } from 'react';
import { Button } from 'antd';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import { IExtendedRestaurantBankSettings } from 'types';
import { NEW_BANK_SETTINGS_BLOCK_PREFIX } from 'appConstants';
import style from './AddNewBlockButton.module.scss';

interface IAddNewBlockButton {
	addBankSettingsBlock: (value: IExtendedRestaurantBankSettings) => void;
}

const AddNewBlockButton: React.FC<IAddNewBlockButton> = ({ addBankSettingsBlock }) => {
	const [blockIDCounter, setBlockIDCounter] = useState(1);

	const handleClick = useCallback(() => {
		setBlockIDCounter((prevState) => prevState + 1);

		const blockId = `${NEW_BANK_SETTINGS_BLOCK_PREFIX}/${blockIDCounter}`;

		addBankSettingsBlock({
			id: blockId,
			merchantName: null,
			paymentTemplateFilePath: null,
			logoPath: null,
			priority: null,
			merchantId: null,
			acquirer: null,
			sbpAccount: null,
			sbpUserLogin: null,
			yandexPaymentTypes: [],
			yandexApiKey: null,
			vivaApiKey: null,
			vivaApiSecret: null,
			isVivaSecretUpdated: false,
			yandexChequeApiToken: null,
			yandexChequeApiPartnerId: null,
			isYandexChequeSecretUpdated: false,
			accNumber: null,
			sector: null,
			sdRef: null,
			isTipsSupported: true,
			isFeeFiscalized: true,
			generateQrInstantly: false,
			paymentTypeId: null,
			smsCode: null,
			tBankPlaceId: null,
			masterWallet: null,
			adyen: null,
		});
	}, [blockIDCounter, addBankSettingsBlock]);

	return (
		<Button
			className={style.button}
			type="text"
			onClick={handleClick}
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#plus`} />
				</svg>
			}>
			<Text translationNameSpace="form" translationKey="addNewBlockButton" asFragment={true} />
		</Button>
	);
};

export default React.memo(AddNewBlockButton);
